import { Children, FC, ReactNode, useState } from 'react';
import { Box, BoxProps, Divider } from '@chakra-ui/react';

import Button from 'components/_core/Button';
import Card from 'components/_core/Card';
import Text from 'components/_core/Text';
import Carousel from 'components/Carousel';

import locales from './locales';

interface CarouselFeaturesLayoutProps extends BoxProps {
  carouselHeight?: string;
  getCtaText?: (params: {
    carouselIndex: number;
    isLast: boolean;
  }) => string | null;
  onDone: () => void;
  pageTitle: ReactNode;
}

const CarouselFeaturesLayout: FC<CarouselFeaturesLayoutProps> = ({
  carouselHeight = 'auto',
  children,
  getCtaText,
  onDone,
  pageTitle,
  ...props
}) => {
  const [carouselIndex, setCarouselIndex] = useState(0);

  const isLast = carouselIndex === Children.count(children) - 1;

  const onNext = () => setCarouselIndex((index) => index + 1);

  return (
    <Box marginX="auto" maxWidth="37.5rem" paddingTop="space-56" {...props}>
      <Text marginBottom="space-40" size="lg" variant="primary">
        {pageTitle}
      </Text>

      <Card size="lg">
        <Carousel
          height={carouselHeight}
          onChange={(index) => setCarouselIndex(index)}
          value={carouselIndex}
        >
          {children}
        </Carousel>

        <Box marginBottom="space-24" width="100%">
          {/* make the divider touching the Card edges */}
          <Box marginX="-space-24">
            <Divider />
          </Box>
        </Box>

        <Button
          alignSelf="center"
          isExpanded
          onClick={isLast ? onDone : onNext}
        >
          {getCtaText?.({ carouselIndex, isLast }) || locales.next}
        </Button>
      </Card>
    </Box>
  );
};

export default CarouselFeaturesLayout;
